import api from './../api';

export default {
  namespaced: true,

  state: {
    item: {}
  },
  getters: {

  },
  actions: {
    listForPatient(store, patientId) {
      return new Promise((resolve, reject) => {
        api.post('protocols/list-for-patient/', {'patientId':patientId}).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error.response);
        });
      });
    }
  },
  mutations: {
    setItem(state, data) {
      state.item = data;
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/protocols.js